import { useCallback, useState } from "react";
import fileDownload from "js-file-download";
import { Entity } from "@common/types/entity";
import { formatISO } from "date-fns";
import { GetAccountTransactionsReportDto } from "../../../common/dto/reports/get-account-transactions-report.dto";
import { getAccountTransactions } from "../../../lib/accountingReports";
import { ReportFormat } from "../../../common/helpers/reports";

export function useGeneralLedgerDownload(
    requestDto: GetAccountTransactionsReportDto | null,
) {
    const [downloading, setDownloading] = useState(false);

    const download = useCallback(
        async (entity: Entity, startDate?: Date, endDate?: Date) => {
            if (downloading || !requestDto) {
                return;
            }
            setDownloading(true);

            const response = await getAccountTransactions({
                ...requestDto,
                format: ReportFormat.XLSX,
            });

            const fileName = `${entity.name} - General Ledger - ${startDate ? formatISO(startDate, { representation: "date" }) : ""} - ${endDate ? formatISO(endDate, { representation: "date" }) : ""}.xlsx`;

            fileDownload(
                response.data,
                fileName,
                response.headers["content-type"],
            );

            setDownloading(false);
        },
        [requestDto, downloading],
    );

    return {
        download,
        downloading,
    };
}
